import { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Container from '@material-ui/core/Container'
import useTranslate from '../i18n/useTranslate'
import { Button, Grid, Paper } from '@material-ui/core'
import InProgress from '../component/um/dashboard/InProgress'
import AverageStatusTime from '../component/um/dashboard/AverageStatusTime'
import Report from '../component/um/dashboard/report/Report'
import AverageProjectTime from '../component/um/dashboard/AverageProjectTime'
import useDashboard, {
    ResponseInprogress,
    ResponseOverview,
    ResponseStatus,
    ResponseFaculty,
    ResponseEachFaculty,
    ResponseDataExport,
    ResponseDataApproveStatus,
} from '../services/um/useDashboard'
import Overview from '../component/um/dashboard/overview/Overview'
import useAuthenStore from '../stores/authen/authenStore'
import DateRangePicker from '../control/datepicker/DateRangePicker'
import { Form } from 'react-final-form'
import moment from 'moment'
import AverageFaculty from '../component/um/dashboard/AverageFaculty'
import AverageEachFaculty from '../component/um/dashboard/AverageEachFaculty'
import GetAppRoundedIcon from '@material-ui/icons/GetAppRounded'
import exportData from '../component/um/dashboard/export-data/exportData'
import Consideration from '../component/um/dashboard/consideration/Consideration '
import useLoading from '../control/loading/useLoading'

const Dashboard = () => {
    const classes = useStyles()
    const translate = useTranslate()
    const authenStore = useAuthenStore()
    const {
        getExcelReport,
        getInprogress,
        getAverageStatus,
        getAverageProject,
        getOverview,
        getAverageFaculty,
        getAverageEachFaculty,
        getDataToExport,
        getDataApproveStatus,
    } = useDashboard()
    const [dataExport, setDataExport] = useState<ResponseDataExport[]>([])
    const [inProgress, setInprogress] = useState<ResponseInprogress[]>([])
    const [approveStatus, setApproveStatus] = useState<ResponseDataApproveStatus[]>([])
    const [averageStatus, setAverageStatus] = useState<ResponseStatus[]>([])
    const [averageProject, setAverageProject] = useState<ResponseInprogress[]>([])
    const [averageFaculty, setAverageFaculty] = useState<ResponseFaculty[]>([])
    const [averageEachFaculty, setAverageEachFaculty] = useState<ResponseEachFaculty[]>([])
    const [overview, setOverview] = useState<ResponseOverview[]>([])
    const [startDate, setStartDate] = useState<string>(moment().add(-1, 'years').format('YYYY-MM-DD').toString())
    const [endDate, setEndDate] = useState<string>(moment().format('YYYY-MM-DD').toString())
    const [facultyID, setFacultyID] = useState<number | null>(null)
    const [faculty, setFaculty] = useState<string>('')
    const [userGroupID, setUserGroupID] = useState<string>('2')

    const loadingHook = useLoading()

    const fetchData = async () => {
        loadingHook.loadingOpen()
        try {
            if (authenStore.profile.userId) {
                const param = {
                    userID: authenStore.profile.userId?.toString(),
                    startDate: startDate,
                    endDate: endDate,
                    userGroupID: String(authenStore.profile.userGroupId),
                }
                const resultInprogress = await getInprogress(param)
                const resultAverageProject = await getAverageProject(param)
                const resultOverview = await getOverview(param)
                const resultAverageFaculty = await getAverageFaculty(param)
                const resultExportData = await getDataToExport(param)
                const resultDataApprove = await getDataApproveStatus(param)
                if (resultInprogress) {
                    setInprogress(resultInprogress)
                }
                if (resultAverageProject) {
                    setAverageProject(resultAverageProject)
                }
                if (resultOverview) {
                    setOverview(resultOverview)
                }
                if (resultAverageFaculty) {
                    setAverageFaculty(resultAverageFaculty)
                }
                if (resultExportData) {
                    setDataExport(resultExportData)
                }
                if (resultDataApprove) {
                    setApproveStatus(resultDataApprove)
                }
            }
        } finally {
            loadingHook.loadingClose()
        }
    }

    const handleChageDate = (val: Record<string, any>) => {
        setStartDate(val.startDate)
        setEndDate(val.endDate)
    }

    const handleChangeUserGroupID = (val: string) => {
        setUserGroupID(val)
    }

    const handleClickFacultyID = (facultyID: number, faculty: string) => {
        setFacultyID(facultyID)
        setFaculty(faculty)
    }

    const handleExportExcel = async () => {
        const param = {
            userID: authenStore?.profile?.userId?.toString() || '',
            startDate: startDate,
            endDate: endDate,
            userGroupID: String(authenStore.profile.userGroupId),
        }
        const result = await getExcelReport(param)
        window.open(result.fileUrl)
        // exportData({
        //     data1: { header: dataExport[0].columns, content: dataExport[0].rows },
        //     data2: { header: dataExport[1].columns, content: dataExport[1].rows },
        //     data3: { header: dataExport[2].columns, content: dataExport[2].rows },
        //     data4: { header: dataExport[3].columns, content: dataExport[3].rows },
        //     translate: (value: string) => translate.get(value),
        // })
    }

    useEffect(() => {
        fetchData()
    }, [authenStore.profile.userId, startDate, endDate])

    useEffect(() => {
        const paramForEachFaculty = {
            userID: String(authenStore.profile.userId),
            startDate: startDate,
            endDate: endDate,
            userGroupID: String(authenStore.profile.userGroupId),
            facultyID: facultyID,
        }
        const fetchData = async () => {
            if (!authenStore.profile.userId) return
            loadingHook.loadingOpen()
            try {
                const resultAverageEachFaculty = await getAverageEachFaculty(paramForEachFaculty)
                if (resultAverageEachFaculty) {
                    setAverageEachFaculty(resultAverageEachFaculty)
                }
            } finally {
                loadingHook.loadingClose()
            }
        }

        fetchData()
    }, [facultyID, authenStore.profile.userId])

    useEffect(() => {
        const fetchData = async () => {
            if (authenStore.profile.userId) {
                loadingHook.loadingOpen()
                try {
                    const param = {
                        userID: authenStore.profile.userId?.toString(),
                        startDate: startDate,
                        endDate: endDate,
                        userGroupID,
                    }
                    const resultAverageStatus = await getAverageStatus(param)
                    if (resultAverageStatus) {
                        setAverageStatus(resultAverageStatus)
                    }
                } finally {
                    loadingHook.loadingClose()
                }
            }
        }

        fetchData()
    }, [authenStore.profile.userId, userGroupID])
    return (
        <Container maxWidth="lg">
            <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                    <Typography variant="h5" className={classes.typo} gutterBottom>
                        {translate.get('UM.DASHBOARD.TITLE')}
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={6} className={classes.dateRange}>
                    <Form
                        onSubmit={() => {}}
                        initialValues={{
                            startDate,
                            endDate,
                        }}
                    >
                        {({ values }) => {
                            const formVal = values
                            handleChageDate(formVal)
                            return (
                                <DateRangePicker
                                    names={{
                                        start: 'startDate',
                                        end: 'endDate',
                                    }}
                                    label=""
                                />
                            )
                        }}
                    </Form>
                </Grid>
                <Grid item xs={12} md={12}>
                    <Grid container justify="flex-end" spacing={2}>
                        <Grid item>
                            <Button
                                size="large"
                                variant="outlined"
                                color="primary"
                                startIcon={<GetAppRoundedIcon style={{ color: '#DB5F8E' }} />}
                                onClick={handleExportExcel}
                            >
                                <Typography variant="button">{translate.get('BUTTON.EXPORT')}</Typography>
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} className={classes.resultCard}>
                    <Overview data={overview} />
                </Grid>
                <Grid item xs={12} className={classes.resultCard}>
                    <Consideration data={approveStatus} />
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="h5" className={classes.typo} gutterBottom>
                        {translate.get('UM.DASHBOARD.TITLE_PROJECT')}
                    </Typography>
                </Grid>
                <Grid item xs={12} lg={6}>
                    <Paper className={classes.paper}>
                        <InProgress data={inProgress} />
                    </Paper>
                </Grid>
                <Grid item xs={12} lg={6}>
                    <Paper className={classes.paper}>
                        <AverageProjectTime data={averageProject} />
                    </Paper>
                </Grid>
                <Grid item xs={12}>
                    <Paper style={{ padding: '16px' }}>
                        <AverageStatusTime data={averageStatus} onChange={handleChangeUserGroupID} />
                    </Paper>
                </Grid>
                <Grid item xs={12}>
                    <Paper style={{ padding: '16px' }}>
                        <AverageFaculty data={averageFaculty} onClick={handleClickFacultyID} />
                    </Paper>
                </Grid>
                <Grid item xs={12}>
                    <Paper style={{ padding: '16px' }}>
                        <AverageEachFaculty data={averageEachFaculty} faculty={faculty} />
                    </Paper>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="h5" className={classes.typo} gutterBottom>
                        {translate.get('UM.REPORT.REPORT')}
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Report />
                </Grid>
            </Grid>
        </Container>
    )
}

const useStyles = makeStyles((theme) => ({
    typo: {
        fontWeight: 'bold',
        margin: '16px 0px',
        [theme.breakpoints.down('xs')]: {
            margin: '16px 0px 0px',
        },
    },
    paper: {
        padding: theme.spacing(2),
        minHeight: '400px',
    },
    dateRange: {
        marginTop: '-5px',
    },
    resultCard: {
        padding: '0px',
    },
}))

export default Dashboard
